import React from 'react';
import PropTypes from 'prop-types';

const ReturningBuyer = ({userName}) => (
    <li className="returning-buyer-sc">
        <h6>{i18n.t('seller_card.returning_buyers_seller.title', {userName})}</h6>
        <p>{i18n.t('seller_card.returning_buyers_seller.text')}</p>
    </li>
);

ReturningBuyer.propTypes = {
    userName: PropTypes.string.isRequired
};


export default ReturningBuyer;



// WEBPACK FOOTER //
// ./src/components/stats/ReturningBuyer.js